import series from '@/application/lib/series'

export default {
    data() {
        return {
            view: 'billsForm',
            app: 'bills',
            loading: true,
            invoices: [],
            fields: {
                observations: '',
                date: this.$moment(),
                client: null,
                client_address: '',
                client_country: '',
                client_cp: '',
                client_location: '',
                client_name: '',
                client_state: '',
                client_cif: '',
                client_legal_name: '',
                status: '0',
                iva: 0,
                iva_percent: 0,
                surcharge: 0,
                surcharge_percent: 0,
                discount: 0,
                discount_percent: 0,
                serie: 0,
                serie_r: null,
                concepts: [
                    {
                        article: null,
                        discount: 0,
                        discount_value: 0,
                        expiration_date: this.$moment().format('YYYY-MM-DD'),
                        lot: null,
                        name: '',
                        price: 0,
                        quantity: 1,
                        iva: 0,
                        iva_value: 0,
                        surcharge: 0,
                        surcharge_value: 0,
                    },
                ],
            },
        }
    },
    computed: {
        id() {
            return parseInt(this.$route.params.id, 10) || 0
        },
        config() {
            return this.$gestios.$cache.config
        },
        haveInvoices() {
            if (this.id > 0 && this.invoices.length > 0) return true
            return false
        },
    },
    methods: {
        // Load events
        events(enable = true) {
            if (enable) {
                this.$hub.$on('listBills', () => {
                    this.$router.push({ name: 'bills' })
                })
            } else {
                this.$hub.$off('listBills')
            }
        },
        // Load config
        async loadConfig() {
            return await this.$gestios.config.list(['name', 'address', 'address2', 'CIF', 'mail', 'phone', 'logo'])
        },
        // Load bill
        async load(loading = false) {
            try {
                if (loading) this.loading = true

                if (this.id > 0) {
                    let bill = await this.$gestios.items('bills').get(this.id)

                    if (bill.ok) {
                        bill = bill.data

                        this.fields.client = {
                            key: bill.client._EntityId.toString(),
                            label: bill.client.legal_name,
                            data: bill.client,
                        }

                        this.fields.client_address = bill.client_address
                        this.fields.client_cp = bill.client_cp
                        this.fields.client_location = bill.client_location
                        this.fields.client_name = bill.client_name
                        this.fields.client_legal_name = bill.client_legal_name
                        this.fields.client_country = bill.client_country
                        this.fields.client_state = bill.client_state
                        this.fields.client_cif = bill.client_cif
                        this.fields.date = bill.date
                        this.fields.observations = bill.observations
                        this.fields.status = bill.status

                        // TAXES
                        this.fields.iva = bill.iva
                        this.fields.iva_percent = bill.iva_percent
                        this.fields.surcharge = bill.surcharge
                        this.fields.surcharge_percent = bill.surcharge_percent
                        this.fields.discount = bill.discount
                        this.fields.discount_percent = bill.discount_percent

                        // SERIE
                        this.fields.serie = bill.serie
                        this.fields.serie_r = bill.serie_r

                        this.fields.concepts = []
                        if (bill.concepts) {
                            for (let i = 0; i < bill.concepts.length; i += 1) {
                                const concept = bill.concepts[i]
                                this.fields.concepts.push({
                                    article: {
                                        key: concept.article,
                                        label: concept.text,
                                        data: {
                                            iva: concept.iva,
                                            name: concept.text,
                                        },
                                    },
                                    lot: { key: concept.lot, label: 'Lote ya asignado' },
                                    expiration_date: concept.expiration_date,
                                    price: concept.price,
                                    quantity: concept.quantity,
                                    discount: concept.discount,
                                    discount_value: concept.discount_value,
                                    name: concept.text,
                                    iva: concept.iva,
                                    iva_value: concept.iva_value,
                                    surcharge: concept.surcharge,
                                    surcharge_value: concept.surcharge_value,
                                    // si tiene factura asignada se lo añadimos
                                    ...(!concept.invoice_concept ? {} : { invoice_concept: concept.invoice_concept }),
                                })
                            }
                        }

                        this.checkInvoice()
                    }

                    if (loading) this.loading = false

                    return true
                }
            } catch (error) {
                console.error(error)
                if (loading) this.loading = false
                return false
            }
        },
        // Add/Edit bill
        async save() {
            try {
                this.loading = true

                const params = {
                    // GENERAL
                    observations: this.fields.observations,
                    date: this.fields.date,
                    status: this.fields.status,

                    // SERIE
                    serie: this.fields.serie,
                    serie_r: this.fields.serie_r._EntityId,

                    // CALCULATIONS
                    subtotal: this.totalCalculations.subtotal,
                    total: this.totalCalculations.total,
                    iva: this.totalCalculations.iva.value,
                    iva_percent: this.totalCalculations.iva.percent,
                    surcharge: this.totalCalculations.surcharge.value,
                    surcharge_percent: this.totalCalculations.surcharge.percent,
                    discount: this.totalCalculations.discount.value,
                    discount_percent: this.totalCalculations.discount.percent,

                    // CLIENT
                    client: this.fields.client.key,
                    client_name: this.fields.client_name,
                    client_legal_name: this.fields.client_legal_name,
                    client_address: this.fields.client_address,
                    client_country: this.fields.client_country,
                    client_cp: this.fields.client_cp,
                    client_location: this.fields.client_location,
                    client_state: this.fields.client_state,
                    client_cif: this.fields.client_cif,
                    concepts: [],
                }

                Object.keys(this.fields.concepts).forEach((key) => {
                    const concept = this.fields.concepts[key]

                    if (concept.article) {
                        params.concepts.push({
                            expiration_date: concept.expiration_date,
                            lot: concept.lot.key,
                            text: concept.name,
                            price: concept.price,
                            quantity: concept.quantity,
                            article: concept.article.key,

                            // TAXES
                            iva: this.conceptCalculation[key].iva.percent,
                            iva_value: this.conceptCalculation[key].iva.value,
                            surcharge: this.conceptCalculation[key].surcharge.percent,
                            surcharge_value: this.conceptCalculation[key].surcharge.value,
                            discount: this.conceptCalculation[key].discount.percent,
                            discount_value: this.conceptCalculation[key].discount.value,
                            // si tiene factura asignada se lo añadimos
                            ...(!concept.invoice_concept ? {} : { invoice_concept: concept.invoice_concept }),
                        })
                    }
                })

                params.concepts = JSON.stringify(params.concepts)

                let data
                if (this.id > 0) {
                    data = await this.$gestios.items('bills').edit({ id: this.id, params })
                } else {
                    data = await this.$gestios.items('bills').add({ params, view: this.view })
                }

                if (data.ok) {
                    if (!this.id && this.nextSerie && this.nextSerie === params.serie) {
                        await series.editSerialValue(this.fields.serie_r._EntityId)
                    }
                    this.$router.push({ name: 'bills' })
                }

                this.loading = false
            } catch (error) {
                this.loading = false
                console.error(error)
            }
        },
        generatePdfBill(bill, openAfterCreate, forceMultiple = false) {
            return new Promise((resolve) => {
                this.printing = bill._EntityId

                let uri = `bill/${bill._EntityId}`
                if (forceMultiple) {
                    uri = `bill/combined/${bill._EntityId}`
                } else {
                    const isCombined = bill.concepts.some((c) => c.invoice_concept !== null)
                    if (isCombined) uri = `bill/combined/${bill._EntityId}`
                }

                this.$lambda
                    .get(uri)
                    .then((response) => {
                        const item = response.data
                        this.$gestios.$cache.items('bills').edit({ id: item._EntityId, params: item })
                        this.$message.success('Factura generada 😄')
                        if (openAfterCreate) this.openBill(item)
                        this.printing = false
                        resolve(true)
                    })
                    .catch((err) => {
                        this.$message.error(err.message)
                        this.printing = false
                        resolve(false)
                    })
            })
        },
        async checkInvoice() {
            this.invoices = []

            if (this.id > 0) {
                const filters = {
                    _ParentOperator: 'OR',
                    _Operator: 'OR',
                    Fields: {
                        invoice: {
                            type: 'number',
                            value: this.id,
                            lig: '=',
                        },
                    },
                }

                let invoices = await this.$gestios.items('invoices').list({ filters, limit: 100 })

                if (invoices.ok) {
                    this.invoices = invoices.data
                }
            }
        },
    },
}
